<header class="heading">
    <div class="tabs">
        @if (tab()) {
            <h3 class="title">
                <button type="button" class="label" [class.active]="!tabOpen()" [attr.aria-pressed]="!tabOpen()" (click)="tabOpen.set(false)">
                    @if (icon(); as icon) {
                        <cl-icon [icon]="icon" />
                    }
                    {{ title() }}
                </button>
            </h3>
            <button type="button" class="label" [class.active]="tabOpen()" [attr.aria-pressed]="tabOpen()" (click)="tabOpen.set(true)">{{ tab() }}</button>
        } @else {
            <h3 class="label active">
                @if (icon(); as icon) {
                    <cl-icon [icon]="icon" />
                }
                {{ title() }}
            </h3>
        }
    </div>

    <span class="aside"><ng-content select="[aside]" /></span>
</header>

<div class="card" [class.joined]="!tabOpen()">
    @if (description()) {
        <p class="description">{{ description() }}</p>
    }

    <div class="content">
        <ng-content />
    </div>
</div>
